import { createTheme } from '@mui/material/styles';
import { darkPalette, lightPalette } from './palette';
import overrides from './overrides';

// function to create theme based on mode
const getTheme = (mode = 'dark') => {
  const selectedPalette = mode === 'light' ? lightPalette : darkPalette;

  return createTheme({
    palette: selectedPalette,
    typography: {
      fontFamily: 'inter',
      h1: {
        fontSize: '48px',
      },
      h2: {
        fontSize: '42px',
      },
      h3: {
        fontSize: '36px',
      },
      h4: {
        fontSize: '20px',
        [`@media (min-width:600px)`]: {
          fontSize: '24px',
        },
      },
      h5: {
        fontSize: '20px',
      },
      h6: {
        fontSize: '16px',
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1536,
        xxl: 1760,
      },
    },
    components: {
      ...overrides,
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: '10px',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            borderRadius: '10px',
            padding: '10px 15px',
            color: 'var(--black)',
            fontSize: '16px',
            fontWeight: 600,
            textTransform: 'unset',
            minWidth: 'auto',
            whiteSpace: 'nowrap',
            '@media (max-width:1024px)': {
              whiteSpace: 'normal',
            },
            '&:hover': {
              backgroundColor: 'var(--white)',
              color: 'var(--black)',
            },
          },
          outlined: {
            borderRadius: '10px',
            padding: '10px 15px',
            color: 'var(--white)',
            fontSize: '16px',
            fontWeight: 600,
            textTransform: 'unset',
            minWidth: 'auto',
            whiteSpace: 'nowrap',
            '@media (max-width:1024px)': {
              whiteSpace: 'normal',
            },
            '&:hover': {
              backgroundColor: 'var(--white)',
              color: 'var(--black)',
            },
          },
        },
      },
    },
  });
};

export default getTheme;
